import React from "react";
import Header from "../menu/Header";
import Menu from "../menu/Menu";
import { FaSearch } from "react-icons/fa";
import { useEffect, useState, useContext } from "react";
import { adminContext } from "../../../context/admincontext";
import { Link } from "react-router-dom";
import {
  GetAllAdminTicket,
  GetAllAdminTickets,
} from "../../../services/adminServices";
import Pagination from "../../Pagination/Pagination";
const AdminSuport = () => {
  const [list, setList] = useState([]);
  const [page, setPageNumber] = useState(1);
  const [totalPage, setTotalPage] = useState(1);
  const [selected, setSelected] = useState({});
  const [info, setInfo] = useState({});
  const [loading, setLoading] = useState(1);
  const { setPage } = useContext(adminContext);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setPage("پشتیبانی");
        const { data } = await GetAllAdminTickets(10, page);
        console.log(data);
        setList(data.result);
        setTotalPage(data.totalPage);
      } catch (err) {
        console.log(err);
      }
    };
    fetchData();
  }, [page]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (selected.id) {
          setLoading(1);
          const { data } = await GetAllAdminTicket(selected.id);
          setInfo(data.result);
          console.log(data);
          setLoading(2);
        }
      } catch (err) {
        console.log(err);
        setLoading(3);
      }
    };
    fetchData();
  }, [selected]);
  return (
    <div style={{ paddingTop: "10px" }}>
      <Header />
      <div className="d-flex content-box">
        <Menu />
        <div className="w-100 me-lg-3 ms-lg-5">
          <div className="row g-0 align-items-center my-requstes-filter-box p-2">
            <div className="mb-2 mb-md-0 p-1 col-11 ">
              <input
                placeholder="جستجو"
                className="my-requstes-filter-item w-100"
              />
            </div>
            <div className="col-1 p-1">
              <button
                className="btn p-1 px-md-2"
                style={{ backgroundColor: "#EF971C", color: "#FFF" }}
              >
                <FaSearch />
              </button>
            </div>
          </div>

          <div
            className="mt-4 p-1"
            style={{
              background: " linear-gradient(180deg, #739FB1 0%, #FFF 100%)",
              borderRadius: "25px",
              minHeight: "630px",
            }}
          >
            <div
              className="table-responsive p-0"
              style={{ border: "1px solid #000", borderRadius: "20px" }}
            >
              <table
                className="table table-bordered text-center mb-0"
                style={{ borderRadius: "20px" }}
              >
                <thead>
                  <tr style={{ color: "#000" }}>
                    <th scope="col">شناسه</th>
                    <th scope="col">عنوان</th>
                    <th scope="col">از طرف</th>
                    <th scope="col">تاریخ</th>
                    <th scope="col">وضعیت</th>
                  </tr>
                </thead>
                <tbody>
                  {list.map((i, index) => (
                    <tr style={{ color: "#000" }} key={index}>
                      <td>{index + 1}</td>
                      <td
                        data-bs-toggle="modal"
                        data-bs-target="#staticBackdrop"
                        onClick={() => {
                          setSelected(i);
                        }}
                        style={{ cursor: "pointer" }}
                      >
                        {i.title}
                      </td>
                      <td>{i.role === "User" ? "کاربر" : "کارشناس"}</td>
                      <td>{i.faDate}</td>
                      <td>{i.read ? "خوانده شده" : "خوانده نشده"}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
          <Pagination
            setPageNumber={setPageNumber}
            page={page}
            totalPage={totalPage}
          />
        </div>
      </div>
      <div
        class="modal fade"
        id="staticBackdrop"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabindex="-1"
        aria-labelledby="staticBackdropLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-body">
              {loading === 1 ? (
                <p>منتظر بمانید</p>
              ) : loading === 2 ? (
                <div>
                  <div className="d-flex justify-content-between">
                    <p>{info.Ex_User.name || ""}</p>
                    <p>{info.Ex_User.mobile}</p>
                  </div>
                  <p className="text-end">{info.content}</p>
                </div>
              ) : (
                <p>خطایی روخ داده است مجددا تلاش کنید</p>
              )}
            </div>
            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-secondary"
                data-bs-dismiss="modal"
                onClick={() => {
                  setLoading(1);
                }}
              >
                بستن
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminSuport;
